import { useNavigate } from "react-router-dom";
import SubCategoryList from "../../../features/manageCategories/subCategories/subCategoryList";
import SubCategoryTopbar from "../../../features/manageCategories/subCategories/topbar";

const ManageSubCategories = () => {

  const navigate = useNavigate();

  return (
    <>
      <div className="main_title">
        <h1>Manage Sub Categories</h1>
        <p>
          <button onClick={() => navigate("/dashboard")}>Dashboard</button> - <button onClick={() => navigate("/manage-service-categories")}>Service Categories</button> - Sub Categories
        </p>
      </div>

      <div className="cards">
        <SubCategoryTopbar />
        <SubCategoryList />
      </div>
    </>
  );
};

export default ManageSubCategories;
